// Lib
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// Utils
import { getTempEditorState } from '../../utils/elementTempDataIUtil';

// Selector
import { getElement } from '../../selectors/elementSelector';

const mapStateToProps = createSelector(getElement, (element) => ({
    tempEditorState: getTempEditorState(element),
}));

export default connect(mapStateToProps);
